import PrintComponent from './PrintComponent';
export default PrintComponent;
